import { Phone, ArrowRight } from "lucide-react";

const FinalCta = () => (
  <section className="relative overflow-hidden bg-[#FDC00E] py-16 md:py-24">
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_120%,rgba(246,74,1,0.18),transparent_60%)]"
    />
    <span aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-0 h-[3px] bg-orange/70 origin-left -rotate-[0.6deg]" />
    <div className="container relative z-10 text-center max-w-2xl">
      <h2 className="text-3xl md:text-4xl font-black text-[#1a1a1a] leading-tight mb-3">
        Ready to Get It Gone?
      </h2>
      <p className="text-[#1a1a1a]/80 text-base mb-10">
        Send us a few photos and we'll take care of the rest.
      </p>

      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <a
          href="/#quote"
          className="inline-flex items-center justify-center gap-2 bg-orange text-white px-8 py-4 text-lg font-bold rounded-md hover:bg-orange-deep transition-colors text-center"
        >
          Get Free Quote
          <ArrowRight className="w-5 h-5 shrink-0" />
        </a>
        <a
          href="tel:1800556654"
          data-call-source="final_cta"
          className="flex items-center justify-center gap-2 border-2 border-[#1a1a1a] text-[#1a1a1a] px-8 py-4 text-lg font-bold rounded-md hover:bg-orange/10 hover:border-orange hover:text-orange-deep transition-colors text-center"
        >
          <Phone className="w-5 h-5" />
          Call Now
        </a>
      </div>
    </div>
  </section>
);

export default FinalCta;
